import { useContext } from 'react'
import { DialogContext } from './DialogContext'

const useDialog = () => {
    return useContext(DialogContext)
}

export default useDialog
